import React, { useEffect, useState, Fragment } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { AiFillFunnelPlot } from 'react-icons/ai';
import QueueSegment from './segment';
import { isToday } from '../../../common/utils';

// import { formatShorthand } from '../../../common/utils';

import '../../../containers/Dashboard/dashboard.css';

const Queues = ( { user, aid, uid, viewing, contacts, loans, opps, stages, title, e } ) => {
    const [ queues, setQueues ] = useState( [] ); //[ 'Loan App Started', 'App Completed', 'Ready for Setup', 'Need More Docs', 'Ready for Review', 'Ready for FT', 'Fast Track Submitted'] );
    const [ lists, setLists ] = useState( {} );
    const [ cols, setCols ] = useState( {} );
    const [ actions, setActions ] = useState( {} );

    const d1 = [
        { name: "Ignore", value: 3 },
        { name: "These", value: 1 },
        { name: "Colors", value: 2 }
    ];

    useEffect( () => {
        if ( e && e.queues ) {
            setQueues( e.queues );
        }
    }, [ e ] );

    useEffect( () => {
        let buckets = {};
        let cols = {};
        let actions = {};
        let list = [];
        // const isTodayLocal = isToday;
        
        const isToday = ( dateString, ignoreYear = false ) => {
            const givenDate = new Date( dateString.match( 'T' ) ? dateString : dateString + 'T12:00:00' );
            const today = new Date();
            
            if ( ignoreYear ) {
                givenDate.setFullYear( today.getFullYear() );
            }
        
            const isSameYear = givenDate.getFullYear() === today.getFullYear();
            const isSameMonth = givenDate.getMonth() === today.getMonth();
            const isSameDay = givenDate.getDate() === today.getDate();
            
            return isSameYear && isSameMonth && isSameDay;
        }

        if ( e && e.logic ) {
            queues.forEach( q => {
                const logic = e.logic[q];

                if ( logic && logic.filter ) {
                    list = [];
                    Object.keys( loans ).forEach( lid => {
                        const l = loans[lid];
                        if ( !l ) {
                            return;
                        }
                        if ( !viewing.includes( l.aid ) ) {
                            return;
                        }

                        if ( eval( logic.filter ) ) {
                            let lo;
                            for ( const loid in opps ) {
                                const opp = opps[loid];
                                if ( opp.relationships && opp.relationships.length && opp.relationships[0].lid === l.lid ) {
                                    lo = opp;
                                    break;
                                }
                            }

                            const pri = l.borrowers?.find( f => f.label === 'Primary' );
                            if ( pri ) {
                                const obj = {
                                    id: pri.cid,
                                    aid: l.aid,
                                    lid: lid,
                                    title: `${contacts[pri.cid]?.firstname} ${contacts[pri.cid]?.lastname}`,
                                    sub: '',
                                    c: contacts[pri.cid],
                                    l: l,
                                    lo: lo,
                                    priority: ( logic.priority && l[logic.priority] ) ? l[logic.priority] : '',
                                    due: ( logic.due && l[logic.due] ) ? l[logic.due] : '',
                                    purpose: ( l ) ? l.purpose : ( lo ) ? lo.purpose : '',
                                };

                                if ( logic.fields ) {
                                    const fields = Object.keys( logic.fields );
                                    fields.forEach( f => {
                                        obj[f] = ( l[logic.fields[f]] ) ? l[logic.fields[f]] : '';
                                    } );
                                }

                                list.push( obj );
                            }
                        }
                    } );
                    if ( logic.sort ) {
                        const priDate = logic.sort.priDate;
                        const secDate = logic.sort.secDate;
                        const flag = logic.sort.priorityFlag;

                        list.sort( ( a, b ) => {
                            const la = loans[a.lid];
                            const lb = loans[b.lid];
                            let ad;
                            let bd;

                            if ( flag ) {
                                if ( la[flag] === 'High' && lb[flag] === 'High' ) {
                                    return 0;
                                } else if ( la[flag] === 'High' ) {
                                    return -1;
                                } else if ( lb[flag] === 'High' ) {
                                    return 1;
                                }
                            }

                            if ( priDate ) {
                                if ( la && la[priDate] ) {
                                    ad = new Date( la[priDate] );
                                }
                                if ( lb && lb[priDate] ) {
                                    bd = new Date( lb[priDate] );
                                }
                            }

                            if ( secDate ) {
                                if ( ad && bd ) {
                                    return ( ad.getTime() - bd.getTime() );
                                }
                                if ( ad ) {
                                    return -1;
                                }
                                if ( bd ) {
                                    return 1;
                                }
        
                                if ( la[secDate] ) {
                                    ad = new Date( la[secDate] );
                                }
                                if ( lb[secDate] ) {
                                    bd = new Date( lb[secDate] );
                                }   
                            }
    
                            if ( !ad && !bd ) {
                                return 0;
                            } else if ( !ad ) {
                                return 1;
                            } else if ( !bd ) {
                                return -1;
                            }
    
                            return ( bd.getTime() - ad.getTime() );
                        } );
                    }
                }

                // console.log( q, list );
                buckets[q] = list;
                cols[q] = logic.cols;
                actions[q] = logic.actions;
            } );
        }

        setLists( buckets );
        setCols( cols );
        setActions( actions );
    }, [ e, queues, contacts, loans, opps, viewing ] );

    return (
        <Fragment>
            <Row className='tf-dashboard-section-header mx-2'>
                <Col className='p-2 tf-dashboard-section-header-title'>
                    <AiFillFunnelPlot />
                    <span className='ps-2'>{title}</span>
                </Col>
            </Row>
            <Row className='p-0' style={ { overflowX: 'auto' } }>
                {
                    queues.map( ( q, idx ) => {
                        return (
                            <Col key={`paprogress-${idx}`} className='p-0'>
                                <QueueSegment 
                                    chartTitle = { lists[q] ? lists[q].length.toString() : "0" }
                                    chartSub = 'Files'
                                    chartData = {d1}
                                    gridTitle = {q}
                                    gridData = { lists[q] ? lists[q] : [] }
                                    gridCols = { cols[q] ? cols[q] : '' }
                                    gridActions = { actions[q] ? actions[q] : '' }
                                    // gridActions = {actions}
                                />
                            </Col>
                        )
                    })
                }
            </Row>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    aid: state.user.aid,
    uid: state.user.email,
    viewing: state.user.viewing,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    opps: state.leadopps.byId,
    stages: state.user.meta.loan.picklist.stage
} );
  
const mapDispatch = ( dispatch ) => ( {
    // loadNotes: dispatch.contacts.loadContactNotes
} );
  
export default connect( mapProps, mapDispatch )( Queues );